// @flow
import * as React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Button, Input, Row } from 'angieslist-react-components';
import { size, debounce, get, isEmpty } from 'lodash';
import CityDetails from './CityDetails';
import CitySearchResults from './CitySearchResults';
import serviceAreaMapActions from '../../common/service-area/serviceAreaMapActions';
import type { ServiceAreaMapReducerStateInterface } from '../../common/service-area/serviceAreaMapReducerTypes';

type Props = {
  onClose: () => void,
  serviceProviderId: string,
  searchCities: typeof serviceAreaMapActions.searchCities,
  getCityDetails: typeof serviceAreaMapActions.getCityDetails,
  serviceAreaMapStore: ServiceAreaMapReducerStateInterface,
  selectedPostalCodes: Set<string>,
  onClickPostalCode: (
    postalCode: string,
    analyticsEventName: string,
    analyticsProps?: {}
  ) => void,
  onClickAdZone: (
    analyticsEventName: string,
    analyticsProps?: {},
  ) => void,
};

type State = {
  searchQuery: string,
  selectedCity: string,
}

export class CitySelectionComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      searchQuery: '',
      selectedCity: '',
    };
  }

  state: State;
  props: Props;

  handleTextInput: ((e: any) => void) = (e: any): void => {
    if (size(e.target.value) > 2) {
      this.doSearch(e.target.value);
    }
    this.setState({ searchQuery: e.target.value });
  }

  doSearch: any = debounce((value) => {
    this.props.searchCities(value);
  }, 200)

  showCityPostalCodes: ((cityId: string, cityName: string) => void) =
  (cityId: string, cityName: string) => {
    this.setState({ selectedCity: cityName });
    this.props.getCityDetails(this.props.serviceProviderId, +cityId);
  }

  clearCitySelection: (() => void) = () => this.setState({ selectedCity: '' });

  render(): React.Node {
    const {
      searchCities, serviceAreaMapStore: { citySearch, cityDetails, serviceArea },
      selectedPostalCodes, onClickPostalCode, onClose, onClickAdZone,
    } = this.props;
    const advertisingArea = get(serviceArea, 'response.advertisingArea.postalCodes', []);
    return (
      <div style={{ margin: '36px 32px 36px 32px', height: '100%' }}>
        <Choose>
          <When condition={this.state.selectedCity}>
            <CityDetails
              isLoading={cityDetails.isLoading}
              error={cityDetails.error}
              cityName={this.state.selectedCity}
              postalCodes={get(cityDetails, 'response.postalCodes')}
              onClose={onClose}
              onBack={this.clearCitySelection}
              selectedPostalCodes={selectedPostalCodes}
              advertisingPostalCodes={advertisingArea}
              onClickPostalCode={onClickPostalCode}
              onClickAdZone={onClickAdZone}
            />
          </When>
          <Otherwise>
            <Row>
              <Button
                className="icon icon-close pull-right text-secondary"
                id="city-selection--close"
                bsStyle="link"
                bsSize="large"
                onClick={onClose}
              />
            </Row>
            <Row style={{ marginTop: '1.5em' }}>
              <Input
                id="city-selection--input"
                type="text"
                placeholder="Search by City"
                onChange={this.handleTextInput}
                onKeyPress={(event) => {
                  if (event.key === 'Enter') {
                    event.preventDefault();
                    searchCities(this.state.searchQuery);
                  }
                }}
              />
            </Row>
            <CitySearchResults
              isLoading={citySearch.isLoading}
              error={citySearch.error}
              showDefault={isEmpty(citySearch.request)}
              cities={get(citySearch, 'response.cities')}
              onCitySelect={this.showCityPostalCodes}
            />
          </Otherwise>
        </Choose>
      </div>
    );
  }
}

export default (compose(connect(
  state => ({
    serviceProviderId: state.serviceProviderId,
    serviceAreaMapStore: state.serviceAreaMap,
  }),
  {
    ...serviceAreaMapActions,
  },
))(CitySelectionComponent): any);



// WEBPACK FOOTER //
// ./src/app/browser/service-areas/CitySelection.js